<template>
  <div class="experiences">
    <div v-for="(experience, index) in experiences" id="slider-container">
      <div id="slider-scroller" class="gallery">
        <div class="slider-item" v-for="image in experience.images">
          <img v-bind:src="image.url"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { deliveryClient } from '@/kontent.js'
  import $ from 'jquery'

  export default {
    name: 'experiences',
    props: ['limit'],
    data: function() {
      return {
        experiences: []
      }
    },
    created: function(){
      var query = deliveryClient
      .items()
      .type('ervaringsgebied')
      .toPromise()
      .then(response => {
        this.$data.experiences = response.items.map(item => ({
          title: item.titel_van_ervaringsgebied.value,
          images: item.logo_s_van_bedrijven_om_ervaring_aan_te_tonen.value,
        }))
      })
    },
    mounted(){
      function slideSlider(){
      $("#slider-scroller").css({"left":"0%","transition":"all 0s linear"});
      $("#slider-scroller").css({"left": String(parseInt($("#slider-scroller").css("left")) - 500) + "px","transition":"all 5s linear"});
      setTimeout(function(){moveSliderItem()}, 1000);
    }

    function moveSliderItem(){
      $("#slider-scroller div").first().detach().appendTo($("#slider-scroller"));
      slideSlider();
    }

    slideSlider();
    }
  }
</script>
